/**
 * הגדרות מערכת – נשמרות ב-Firestore במסמך settings/app
 * מנהל יכול לערוך דרך דף ההגדרות.
 */
export interface AppSettings {
  /** אחוז מע"מ (0–100), למשל 17 */
  vatRatePercent?: number;
  /** מספר תיק במע"מ / ח.פ. להדפסה בחשבונית */
  vatNumber?: string;
  /** רשימת סוגי תקלה לבחירה בטופס קריאת שירות */
  issueTypes?: string[];
  /** רשימת ציוד נלווה לבחירה */
  accessories?: string[];
  /** רשימת קטגוריות מכשיר לבחירה */
  deviceCategories?: string[];
  /** רשימת מותגים לבחירה בטופס מכשירים */
  deviceBrands?: string[];
  updatedAt?: string;
}

export const DEFAULT_ISSUE_TYPES = [
  'לא נדלק',
  'מסך שבור',
  'פנל שבור',
  'סוללה נפוחה',
  'פלסטיקה שבורה',
  'מסך עליון שבור',
  'מסך תחתון שבור',
  'מגע לא עובד',
  'טאצ שבור',
  'לא נטען',
  'שקע טעינה שבור',
  'שקע אוזניות לא עובד',
  'מצלמה לא עובדת',
  'מצלמת סלפי לא עובדת',
  'כפתורים לא עובדים',
  'כפתורים שבורים',
  'רמקול לא עובד',
  'מיקרופון תקול',
  'לא שומעים בהסרטות',
  'עדכון גירסה',
  'עדכון גרסה',
  'פלט מסך קרוע',
  'לא קורא כרטיס זיכרון',
  'לא קורא כרטיס משחק',
  'מחקו את תוכן הכרטיס',
  'תושבת כרטיס שבורה',
  'עדשה לא נפתחת',
  'עדשה שבורה',
  'רכיב וייפי WIFI תקול',
  'בלוטוס לא תקין',
  'רכיב תקול',
  'לוח תקול',
  'קורוזיה',
  'כרטיס משחק',
].sort((a, b) => a.localeCompare(b, 'he'));

export const DEFAULT_ACCESSORIES = [
  'סוללה',
  'כרטיס זיכרון',
  'כרטיס משחק',
  'כיסוי',
  'מטען',
];

export const DEFAULT_DEVICE_CATEGORIES = [
  'כללי',
  'אוזניות',
  'נגנים',
  'קונסולות משחק',
  'מצלמות ילדים',
  'מצלמות',
  'מצלמות קנון CANON',
  'משחקי ילדים',
  'רמקולים',
  'כבלים ומטענים',
  'טאבלטים',
  'אחסון',
  'מכשירי קשר',
];

export const DEFAULT_DEVICE_BRANDS = [
  'iHip',
  'JBL',
  'Nintendo',
  'Maxell',
  'SANDISK',
  'FUJIFILM',
  'PANASONIC',
  'Samsung',
  'XENOX',
  'Philips',
  'CANON',
  'Lenovo',
  'SONY',
  'Gripo',
  'Anker',
  'GameStar',
];

export const DEFAULT_VAT_RATE_PERCENT = 17;
